import { EntityVariation } from "../../entity/EntityVariation";

export class DtoVariationsDeleteRes extends EntityVariation {
  public message: string | null = null;
}
